class StickyAtcDualBuilder extends HTMLElement {
  constructor() {
    super();
    this.customBuilderForm = null;
    this.observer = null;
    this.builderWatcher = null;
    this.scrollTimeout = null;
    this.addToCartText = '';
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.cleanup();
  }

  init() {
    const stickyButton = this.querySelector('.sticky-builder-atc');
    const atcTextEl = stickyButton?.querySelector('.atc-text');
    
    if (!stickyButton) return;
    
    // Get the translated text from the button's data attribute
    this.addToCartText = stickyButton.getAttribute('data-atc-text') || 'Add to Cart';
    
    // Bind event listeners
    this.bindEvents(stickyButton, atcTextEl);
    
    // Start observing when builder is found
    if (!this.startObserving()) {
      this.watchForBuilder();
    }
    
    // Initial visibility check
    setTimeout(() => {
      this.handleStickyVisibility();
      this.syncWithBuilder();
    }, 200);
  }

  bindEvents(stickyButton, atcTextEl) {
    // Handle sticky button click
    stickyButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.handleStickyButtonClick(stickyButton, atcTextEl);
    });

    // Listen for changes in quantity inputs
    document.addEventListener('click', (e) => {
      if (e.target.closest('.custom-builder-form__product-quantity .plus') || 
          e.target.closest('.custom-builder-form__product-quantity .minus')) {
        setTimeout(() => this.syncWithBuilder(), 50);
      }
    });

    // Listen for accessory changes and radio button changes
    document.addEventListener('change', (e) => {
      if (e.target.name === 'accessory' || e.target.name === 'builder-flavour') {
        setTimeout(() => this.syncWithBuilder(), 50);
      }
    });

    // Also sync on scroll (when sticky becomes visible)
    window.addEventListener('scroll', () => {
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(() => {
        this.handleStickyVisibility();
        this.syncWithBuilder();
      }, 100);
    });
  }

  handleStickyButtonClick(stickyButton, atcTextEl) {
    // Show loading state
    const spinner = stickyButton.querySelector('.atc-spinner');
    const text = stickyButton.querySelector('.atc-text');
    
    if (spinner) spinner.classList.remove('hidden');
    if (text) text.textContent = 'Añadiendo...';
    stickyButton.disabled = true;
    
    // Trigger the builder's add to cart
    const builderButton = stickyButton.builderElement?.querySelector('.bundle-add-to-cart');
    if (builderButton) {
      builderButton.click();
    }
    
    // Reset loading state after a delay
    setTimeout(() => {
      if (spinner) spinner.classList.add('hidden');
      stickyButton.disabled = false;
      this.syncWithBuilder(); // Refresh state
    }, 2000);
  }

  // Function to show/hide sticky based on scroll and product form visibility
  handleStickyVisibility() {
    const stickyBuilder = this.closest('[data-view="sticky-atc-dual-builder"]');
    if (!stickyBuilder) return;

    // Try to find any of the builders
    const customBuilder = document.querySelector('custom-builder-kit-form') || 
                         document.querySelector('custom-builder-form-fitblend') || 
                         document.querySelector('custom-builder-form');
    if (!customBuilder) return;
    
    // Check if we should show on this device
    const showOnDesktop = stickyBuilder.dataset.showOnDesktop === 'true';
    const showOnMobile = stickyBuilder.dataset.showOnMobile === 'true';
    const isMobile = window.innerWidth < 768;
    
    if ((!isMobile && !showOnDesktop) || (isMobile && !showOnMobile)) {
      stickyBuilder.classList.add('translate-y-full');
      return;
    }
    
    const addToCartButton = customBuilder.querySelector('.bundle-add-to-cart');
    const addToCartRect = addToCartButton?.getBoundingClientRect();
    
    // Show sticky when the main add to cart button is not fully visible
    const shouldShowSticky = addToCartRect && 
      (addToCartRect.top > window.innerHeight - 80 || addToCartRect.bottom < 80);
    
    if (shouldShowSticky) {
      stickyBuilder.classList.remove('translate-y-full');
    } else {
      stickyBuilder.classList.add('translate-y-full');
    }
  }

  // Function to find the custom builder form (adapted for dual builders)
  findCustomBuilder() {
    if (!this.customBuilderForm) {
      this.customBuilderForm = document.querySelector('custom-builder-kit-form') || 
                               document.querySelector('custom-builder-form-fitblend') || 
                               document.querySelector('custom-builder-form');
    }
    return this.customBuilderForm;
  }

  // Function to sync with builder state
  syncWithBuilder() {
    const builder = this.findCustomBuilder();
    if (!builder) return;
    
    let totalQuantity = 0;
    let totalPrice = 0;
    
    // Handle kit builder (has radio buttons for flavors)
    if (builder.tagName.toLowerCase() === 'custom-builder-kit-form') {
      const selectedFlavor = builder.querySelector('input[name="builder-flavour"]:checked');
      if (selectedFlavor) {
        totalQuantity = 1; // Kit always has 1 unit
      }
    } else {
      // Handle fitblend and other builders (have quantity inputs)
      const quantityInputs = builder.querySelectorAll('.custom-builder-form__product-quantity input[type="number"]');
      quantityInputs.forEach(input => {
        const quantity = parseInt(input.value) || 0;
        totalQuantity += quantity;
      });
    }
    
    // Get price from the builder's atc-price element
    const builderPrice = builder.querySelector('.atc-price').textContent || this.querySelector('.sticky-builder-atc').dataset.price;
    if (builderPrice) {
      const priceText = builderPrice.replace('€', '').replace('-', '').trim();
      totalPrice = parseFloat(priceText) || 0;
    }

    console.log("Builder price", builderPrice);
    
    // Update sticky ATC state
    this.updateStickyState(totalQuantity, totalPrice, builder);
  }

  updateStickyState(quantity, price, builderElement) {
    const stickyButton = this.querySelector('.sticky-builder-atc');
    const atcTextEl = stickyButton?.querySelector('.atc-text');
    
    if (!stickyButton) return;

    if (quantity > 0 && price > 0) {
      stickyButton.disabled = false;
      stickyButton.classList.remove('disabled');
      // Show price + text
      if (atcTextEl) {
        atcTextEl.textContent = `${price.toFixed(2)}€ - ${this.addToCartText}`;
      }
    } else {
      // Never show "Select products" - always keep enabled since there's always a preselected product
      stickyButton.disabled = false;
      stickyButton.classList.remove('disabled');
      // Show text without price if no price calculated yet
      if (atcTextEl) {
        atcTextEl.textContent = this.addToCartText;
      }
    }
    
    // Store reference to builder for clicking
    stickyButton.builderElement = builderElement;
  }

  // Start observing when builder is found
  startObserving() {
    const builder = this.findCustomBuilder();
    if (builder) {
      this.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
            // Check if the change was in the builder price element
            const target = mutation.target;
            if (target.classList?.contains('atc-price') || 
                target.parentElement?.classList?.contains('atc-price') ||
                target.closest?.('.atc-price')) {
              setTimeout(() => this.syncWithBuilder(), 10);
            }
          }
        });
      });
      
      this.observer.observe(builder, {
        childList: true,
        subtree: true,
        characterData: true
      });
      
      // Initial sync
      setTimeout(() => this.syncWithBuilder(), 100);
      return true;
    }
    return false;
  }

  // Watch for builder to appear in DOM
  watchForBuilder() {
    this.builderWatcher = new MutationObserver(() => {
      if (this.findCustomBuilder()) {
        this.builderWatcher.disconnect();
        this.startObserving();
      }
    });
    
    this.builderWatcher.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  cleanup() {
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.builderWatcher) {
      this.builderWatcher.disconnect();
    }
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
  }
}

// Define the custom element
customElements.define('sticky-atc-dual-builder', StickyAtcDualBuilder);
